import { gql } from '@apollo/client'

export const QUERY_APP_SETTINGS = gql`
  query getAppSettings($merchantId: uuid!) {
    app_settings(where: { merchant_id: { _eq: $merchantId } }) {
      id
      sections
      location_products_view
    }
  }
`

export const SEND_APP_NOTIFICATION = gql`
  mutation sendAppNotifications(
    $merchantId: ID!
    $startDate: String!
    $endDate: String!
    $storeIds: [ID]!
    $title: String!
    $notificationTitle: String!
    $notificationBody: String!
    $hasOrdered: Boolean
    $hasStamped: Boolean
    $hasUnredeemedRewards: Boolean
    $hasBirthday: Boolean
    $count: Int
    $exception: Boolean
    $sendToAll: Boolean
    $isPublished: Boolean
    $publishOn: String
  ) {
    sendAppNotification(
      merchantId: $merchantId
      startDate: $startDate
      endDate: $endDate
      storeIds: $storeIds
      title: $title
      notificationTitle: $notificationTitle
      notificationBody: $notificationBody
      hasOrdered: $hasOrdered
      hasStamped: $hasStamped
      hasUnredeemedRewards: $hasUnredeemedRewards
      hasBirthday: $hasBirthday
      count: $count
      exception: $exception
      sendToAll: $sendToAll
      isPublished: $isPublished
      publishOn: $publishOn
    )
  }
`

export const PREVIEW_CAMPAIGN_CUSTOMER_DEVICE_TOKENS = gql`
  query previewCampaignCustomerDeviceTokens(
    $startDate: String!
    $endDate: String!
    $storeIds: [ID]!
    $hasOrdered: Boolean
    $hasStamped: Boolean
    $hasUnredeemedRewards: Boolean
    $hasBirthday: Boolean
    $count: Int
    $exception: Boolean
    $sendToAll: Boolean
  ) {
    previewCampaignCustomerDeviceTokens(
      startDate: $startDate
      endDate: $endDate
      storeIds: $storeIds
      hasOrdered: $hasOrdered
      hasStamped: $hasStamped
      hasUnredeemedRewards: $hasUnredeemedRewards
      hasBirthday: $hasBirthday
      count: $count
      exception: $exception
      sendToAll: $sendToAll
    ) {
      id
    }
  }
`

export const LIST_CAMPAIGNS = gql`
  query listCampaigns($isPublished: Boolean) {
    listCampaigns(isPublished: $isPublished) {
      id
      title
      notificationTitle
      notificationBody
      notificationsSentTotal
      notificationsSentSuccess
      publishOn
      insertedAt
    }
  }
`

export const UPDATE_CAMPAIGN = gql`
  mutation updateCampaign($id: ID!, $campaign: CampaignParams!) {
    updateCampaign(id: $id, campaign: $campaign) {
      id
      title
      notificationTitle
      notificationBody
      publishOn
      insertedAt
    }
  }
`

export const ARCHIVE_CAMPAIGN = gql`
  mutation archiveCampaign($id: ID!) {
    archiveCampaign(id: $id) {
      id
    }
  }
`
